import React from 'react';
import { object, func, array } from 'prop-types';

import DirectionsIcon from '../../../../assets/images/icons/maps/directions.svg';
import ShareIcon from '../../../../assets/images/icons/share_icon.svg';
import UserImageLink from '../UserImageLink';
import CircleButton from '../CircleButton';
import MenuPop from '../MenuPop';

import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';
import * as styles from './styles/styles.module.scss';

const HeaderButtons = ({ context, user, handleDirectionsClick, handleShareClick, menuItems }) => {
  return (
    <div className={styles.buttonPanel}>
      <div className={styles.userImage}>
        <UserImageLink context={context} user={user} />
      </div>
      <CircleButton
        title={StringConstantsMixin.strings.DIRECTIONS}
        icon={DirectionsIcon}
        className={styles.circleIcon}
        onClick={handleDirectionsClick}
      />
      <CircleButton title={StringConstantsMixin.strings.SHARE} icon={ShareIcon} className={styles.circleIcon} onClick={handleShareClick} />
      <MenuPop variant="circle" items={menuItems} />
    </div>
  );
};

export default HeaderButtons;

HeaderButtons.propTypes = {
  context: object.isRequired,
  user: object.isRequired,
  handleDirectionsClick: func.isRequired,
  handleShareClick: func.isRequired,
  menuItems: array.isRequired
};
